// Registry for /curriculum/district/:slug landing pages. Two variants the page renders:
//   - curriculum-aligned (Peninsula = Amplify CKLA; Lex-Rich 5 = Benchmark Advance):
//     real adopted curriculum + aligned lessons. (Lex-Rich 5 ALSO carries social proof.)
//   - re-engagement / social-proof: a district with existing adoption but no lessons yet
//     (lessons: []). NO fabricated curriculum claim.
import { PENINSULA_DISTRICT, CurriculumLesson, CurriculumDistrict } from './peninsula-district';
import { LEXRICH5_DISTRICT } from './lexrich5-district';

export type { CurriculumLesson, CurriculumDistrict };

export const DISTRICT_BY_SLUG: Record<string, CurriculumDistrict> = {
  peninsula: PENINSULA_DISTRICT,
  lexrich5: LEXRICH5_DISTRICT,
};
